







































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import rooms, { Room, RoomsList } from '@/services/Rooms'
import videos, { Video, VideoList } from '@/services/Videos'

@Component
export default class RestaurantSettings extends Vue {
  @Prop({ required: true, default: null })
  // @ts-ignore
  public invokingEl: HTMLElement | null

  @Prop()
  public activeSeatingId!: string

  public roomId: string = ''
  public roomName: string = ''
  public roomSize: number | null = null
  public roomGuestVolume: number | null = null
  public roomArtistVolume: number | null = null
  public isRoomPrivate: boolean = false
  public isEndRoom: boolean = false

  public rooms = rooms
  public roomsList: Room[] = []
  public restaurantId: string = ''
  public editing = false
  public changingRoomOrder = false

  public videosList: Video[] = []
  public newVideoDescription: string = ''
  public newVideoYtId: string = ''
  public videoInEditMode: string | null = null

  mounted() {
    // Focus on the first field
    ;(this.$refs.roomName as HTMLInputElement).focus()

    this.restaurantId = this.$router.currentRoute.params.restaurantId

    rooms.observeRooms(this.restaurantId, roomsList => {
      this.roomsList = roomsList
    })

    videos.observeVideos(this.restaurantId, videosList => {
      this.videosList = videosList
    })
  }

  public close() {
    if (this.invokingEl) {
      this.invokingEl.focus()
    }

    this.$emit('closeModal')
  }

  public get showOrderButton() {
    return this.roomsList.every(
      room => room.sortingOrder !== null && room.sortingOrder !== undefined
    )
  }

  public async saveRoom() {
    if (!this.isFormValid) {
      return
    }

    // @ts-ignore we already check this with isFormValid
    const room: PartialRoom<Room> = {
      name: this.roomName,
      size: this.roomSize,
      artistVolume: Number(this.roomArtistVolume),
      guestVolume: Number(this.roomGuestVolume),
      private: this.isRoomPrivate,
      isEndRoom: this.isEndRoom,
      ...(!this.editing && { sortingOrder: Object.keys(this.roomsList).length }),
    }

    this.editing
      ? await rooms.updateRoom(this.restaurantId, this.roomId, room)
      : await rooms.createRoom(this.restaurantId, room)

    this.roomName = ''
    this.roomSize = this.roomArtistVolume = this.roomGuestVolume = null
    this.editing = false
  }

  public async deleteRoom(roomId: string) {
    if (confirm(this.$i18n.t('staff.rooms.confirm') + '')) {
      await rooms.deleteRoom(this.restaurantId, this.activeSeatingId, roomId)
      this.roomsList.forEach(async (room, index) => {
        await rooms.changeRoomOrder(this.restaurantId, room.id, index)
      })
    }
  }

  public async deleteVideo(videoId: string) {
    if (confirm(this.$i18n.t('staff.videos.confirm') + '')) {
      await videos.deleteVideo(this.restaurantId, videoId)
    }
  }

  public async editRoom(room: Room) {
    const { id, name, size, artistVolume, guestVolume } = room

    this.roomId = id
    this.roomName = name
    this.roomSize = size
    this.roomArtistVolume = artistVolume
    this.roomGuestVolume = guestVolume
    this.isRoomPrivate = room.private || false
    this.isEndRoom = room.isEndRoom || false

    this.editing = true
  }

  public editVideo(video: Video) {
    this.videoInEditMode = video.id ? video.id : null
  }

  public async saveVideo(video: Video) {
    if (!video.id) {
      return
    }
    await videos.updateVideo(this.restaurantId, video.id, {
      description: video.description,
      youtubeId: video.youtubeId,
      id: null,
    })
    this.videoInEditMode = null
  }

  public async changeRoomOrder(room: Room, newSortingOrder: number) {
    const targetRoom = this.roomsList.find(r => r.sortingOrder === newSortingOrder)
    if (this.changingRoomOrder || !targetRoom) {
      return
    }

    this.changingRoomOrder = true

    await rooms.changeRoomOrder(this.restaurantId, room.id, newSortingOrder)
    await rooms.changeRoomOrder(this.restaurantId, targetRoom.id, room.sortingOrder)

    this.changingRoomOrder = false
  }

  public async addNewVideo() {
    if (!this.isNewVideoValid) {
      return
    }

    const video: Video = {
      youtubeId: this.newVideoYtId,
      description: this.newVideoDescription,
      id: null,
    }

    await videos.createVideo(this.restaurantId, video)

    this.newVideoDescription = ''
    this.newVideoYtId = ''
  }

  public get isNewVideoValid() {
    return !!(this.newVideoDescription && this.newVideoYtId)
  }

  public get isFormValid() {
    return (
      this.roomName &&
      this.roomName.length >= 2 &&
      this.roomName.length <= 25 &&
      this.roomSize &&
      this.roomSize >= 1 &&
      this.roomSize <= 12 &&
      this.roomGuestVolume !== null &&
      this.roomGuestVolume !== undefined &&
      this.roomGuestVolume >= 0 &&
      this.roomGuestVolume <= 100 &&
      this.roomArtistVolume !== null &&
      this.roomArtistVolume !== undefined &&
      this.roomArtistVolume >= 0 &&
      this.roomArtistVolume <= 100
    )
  }

  public toggleEndRoom() {
    if (this.isEndRoom) {
      this.isRoomPrivate = true
    }
  }

  public togglePrivateRoom() {
    if (this.isEndRoom && !this.isRoomPrivate) {
      this.isEndRoom = false
    }
  }
}
